import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Security } from '../../types/entities';

import { initialState, SecurityState } from './state';

const securitySlice = createSlice({
  name: 'security',
  initialState,
  reducers: {
    reset: () => initialState,
    loading: (state: SecurityState, action: PayloadAction<boolean>) => {
      state.error = undefined;
      state.loading = action.payload;
      state.loaded = !action.payload;
    },
    success: (state: SecurityState, action: PayloadAction<Security[]>) => {
      state.error = undefined;
      state.loading = false;
      state.loaded = true;
      state.securities = action.payload;
    },
    fail: (state: SecurityState, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
      state.loaded = true;
      state.securities = [];
    },
    add: (state: SecurityState, action: PayloadAction<Security>) => {
      state.securities.push(action.payload);
      state.loading = false;
      state.loaded = true;
    },
    update: (state: SecurityState, action: PayloadAction<Security>) => {
      const dbEntry = state.securities.find((x) => x.id === action.payload.id);
      if (!!dbEntry) {
        const index = state.securities.indexOf(dbEntry);
        state.securities[index] = action.payload;
      }
      state.loading = false;
      state.loaded = true;
    },
    remove: (state: SecurityState, action: PayloadAction<Security>) => {
      const entry = state.securities.find((x) => x.symbol === action.payload.symbol);
      const index = entry ? state.securities.indexOf(entry) : -1;
      if (index !== -1) {
        state.securities.splice(index, 1);
      }
      state.loading = false;
      state.loaded = true;
    }
  }
});

const { actions, reducer } = securitySlice;
export const { reset, loading, success, fail, add, update, remove } = actions;
export default reducer;
